import { createSelector } from 'reselect';

import { getSelectedDealer } from 'selectors/dealerSelectors';
import { getProps } from 'utils/selectors';

/** @returns {import('modules/steps/reducer').StepReducer} */
export const getState = state => state.steps;

export const getData = createSelector(getState, steps => steps.data);

export const getUI = createSelector(getState, steps => steps.ui);

export const isSelectedStepModeEnabled = createSelector(
  getSelectedDealer,
  getProps,
  (dealer, mode) => dealer?.config?.steps?.[mode]?.enabled ?? dealer?.config?.steps?.[mode]?.steps?.length > 0
);
